import {DeprecatedDefaultSchema, Schema as NamedSchema} from '../legacy/Schema'

export default DeprecatedDefaultSchema
export const Schema = NamedSchema
export {type SchemaValidationResult} from '../sanity/typedefs'
